import { useWizardStore, type SubscriptionType } from '../wizardStore';
import { PrimaryButton } from '@/shared/ui/PrimaryButton';
import { WizardFooter } from '@/shared/ui/WizardFooter';
import { useT } from '@/shared/lib/i18n';
import { cn } from '@/shared/lib/cn';

interface TypeCardProps {
  selected: boolean;
  onClick: () => void;
  title: string;
  subtitle: string;
}

function TypeCard({ selected, onClick, title, subtitle }: TypeCardProps) {
  return (
    <button
      className={cn(
        'w-full rounded-[18px] p-4 text-left transition-all',
        selected
          ? 'bg-brand-green/10 border-2 border-brand-green shadow-[0_10px_24px_rgba(18,120,90,0.18)]'
          : 'glass-content border border-white/60',
      )}
      onClick={onClick}
    >
      <p className="text-[17px] font-bold">{title}</p>
      <p className="text-[13px] text-text-secondary mt-1">{subtitle}</p>
    </button>
  );
}

export function TypeStep() {
  const { type, update, next } = useWizardStore();
  const t = useT();

  const select = (v: SubscriptionType) => update({ type: v });

  return (
    <div className="flex flex-col gap-4 flex-1">
      <h1 className="text-[24px] font-bold tracking-tight">{t('wizard.type.title')}</h1>

      <TypeCard
        selected={type === 'subscription'}
        onClick={() => select('subscription')}
        title={t('wizard.type.subscription')}
        subtitle={t('wizard.type.subscriptionSub')}
      />
      <TypeCard
        selected={type === 'collection'}
        onClick={() => select('collection')}
        title={t('wizard.type.collection')}
        subtitle={t('wizard.type.collectionSub')}
      />

      <div className="flex-1" />

      <WizardFooter>
        <PrimaryButton onClick={next}>{t('wizard.continue')}</PrimaryButton>
      </WizardFooter>
    </div>
  );
}
